<template>
  <page-wrapper :title="title">
    <group-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></group-list-item>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import GroupListItem from "../components/GroupListItem";

export default {
  components: {
    PageWrapper,
    GroupListItem
  },
  data() {
    const title = "รายการ Ruejai Club Group Category";
    const list = [];

    return {
      title,
      list
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.ruejaiClub.groupCategories.list();

      return response.data.result.map(item => ({
          id: item.id,
          name: item.name,
          route: { name: "RuejaiClubGroupCategoryDetailPage", params: { id: item.id } },
          categoryCount: item.categories.length
        }));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>
